import React, { Component } from 'react';
import { View, Platform } from 'react-native';
import PropTypes from 'prop-types';
import { withTheme } from '../../theme';
import R from '../../core-res/R';
import DRNTouchableWrapper from '../../standard/Button/TouchableButtonWrapper';
import VARIANTS from './variants';
import TopBar from './tabComponent/TopBar';
import BottomBar from './tabComponent/BottomBar';
class TabBar extends Component {
    constructor() {
        super(...arguments);
        this.tabComponent = {
            [VARIANTS.TOP_BAR]: TopBar,
            [VARIANTS.BOTTOM_BAR]: BottomBar,
        };
    }
    render() {
        const { theme, onPress, style, isActive, activeTabColor, variant, label, Icon, showIndicator, smartKey, } = this.props;
        const backgroundColor = theme.lightPrimary;
        const TabBar = this.tabComponent[variant];
        return (<DRNTouchableWrapper accessible={Platform.OS !== 'ios'} onPress={onPress}>
        <View style={[{ backgroundColor, paddingHorizontal: R.spacing.xs }, style]}>
          <TabBar label={label} isActive={isActive} activeTabColor={activeTabColor} Icon={Icon} showIndicator={showIndicator} smartKey={smartKey}/>
        </View>
      </DRNTouchableWrapper>);
    }
}
TabBar.propTypes = {
    isActive: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    theme: PropTypes.object,
    onPress: PropTypes.func.isRequired,
    style: PropTypes.object,
    activeTabColor: PropTypes.string,
    variant: PropTypes.oneOf(Object.values(VARIANTS)),
    Icon: PropTypes.node,
    showIndicator: PropTypes.bool,
    smartKey: PropTypes.string,
};
TabBar.defaultProps = {
    variant: VARIANTS.TOP_BAR,
    showIndicator: false,
};
const DRNTabBar = withTheme(TabBar);
DRNTabBar.VARIANTS = VARIANTS;
export default DRNTabBar;
